import React, { useEffect, useState } from "react";
import { DatePicker, Form, Input, message, Select, Switch } from "antd";
import { capitalize } from 'lodash';
import APIHelper from '../../axios/apiHelper';
import PhysicianAPI from '../../axios/physician/PhysicianApi'
import CaseTagApi from "../../axios/CaseTagApi";
import { CaseFilterMap } from "../../constants/CaseFilter";
import { ConsultTypeEnum } from "../../types/enums";

const { RangePicker } = DatePicker;

const { Option } = Select;
const {
  TELEMEDICINE_CATEGORY_ID,
  STATE_ID,
  CASE_ID,
  PATIENT_FIRST_NAME,
  PATIENT_LAST_NAME,
  TYPE,
  CREATED_DATE_RANGE,
  UPDATED_DATE_RANGE,
  COMPLETED_DATE_RANGE,
  STATUS,
  CASE_TAGS,
  BOOKMARKED,
  PHYSICIAN_ID,
} = CaseFilterMap;

const SwitchWrapper = (props) => {
  const { value, onChange } = props;
  return <Switch checked={value} onChange={onChange} />
}

const FilterForm = (props) => {
  const { telemedicines, states, hideFields, form } = props;
  const [caseStatuses, setCaseStatuses] = useState([]);
  const [caseTags, setCaseTags] = useState([]);
  const [physicians, setPhysicians] = useState([])

  const showPhysician = !hideFields?.includes(PHYSICIAN_ID);

  useEffect(() => {
    showPhysician &&
      PhysicianAPI.getPhysicians()
        .then(res => setPhysicians(res.data.physicians))
        .catch(() => message.error('Unable to fetch list of physicians'));
  }, [showPhysician])

  useEffect(() => {
    APIHelper.fetchLookUp('case-status')
      .then(res => setCaseStatuses(res.data.payload))
      .catch(() => message.error('Unable to fetch list of case status filters'));

    CaseTagApi.getCaseTags()
        .then(res => setCaseTags(res.data.caseTags))
        .catch(() => message.error('Unable to fetch list of case tags'));
  }, [])

  return (
    <Form layout="vertical" form={form}>
      {!hideFields?.includes(CASE_ID) && (
        <Form.Item name={CASE_ID} label="Case Id">
          <Input id="case-filter-case-id-input" placeholder="Filter by Case Id"/>
        </Form.Item>
      )}

      {!hideFields?.includes(STATUS) && (
        <Form.Item name={STATUS} label='Case Status'>
          <Select id="case-filter-status-select" placeholder='Filter by Case Status'>
            {caseStatuses.map(s => <Option key={s._id} value={s.name}>{s.displayName}</Option>)}
          </Select>
        </Form.Item>
      )}

      {!hideFields?.includes(CASE_TAGS) && (
        <Form.Item name={CASE_TAGS} label='Case Tags'>
          <Select id="case-filter-tags-select" mode="tags" placeholder="Case Tags">
            {caseTags.map(t => <Option key={t._id}>{t.tag}</Option>)}
          </Select>
        </Form.Item>
      )}

      {!hideFields?.includes(PATIENT_FIRST_NAME) && !hideFields?.includes(PATIENT_LAST_NAME) && (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Form.Item name={PATIENT_FIRST_NAME} label="Patient First Name" style={{ width: '49%' }}>
            <Input id="case-filter-patient-first-name-input" placeholder="Filter by Patient First Name"/>
          </Form.Item>
          <Form.Item name={PATIENT_LAST_NAME} label="Patient Last Name" style={{ width: '49%' }}>
            <Input id="case-filter-patient-last-name-input" placeholder="Filter by Patient Last Name"/>
          </Form.Item>
        </div>
      )}

      {!hideFields?.includes(TELEMEDICINE_CATEGORY_ID) && (
        <Form.Item name={TELEMEDICINE_CATEGORY_ID} label="Telemedicine Category">
          <Select id="case-filter-category-select" placeholder="Filter by Telemedicine Category">
            {telemedicines?.map((t) => <Option key={t._id} value={t._id}>{t.name}</Option>)}
          </Select>
        </Form.Item>
      )}

      {!hideFields?.includes(PHYSICIAN_ID) && (
        <Form.Item name={PHYSICIAN_ID} label="Assigned Physician">
          <Select id="case-filter-physician-select" placeholder="Filter by Assigned Physician">
            {physicians?.map((p) => (
              <Option key={p._id} value={p._id}>
                {`${p.firstName} ${p.lastName}`}
              </Option>
            ))}
          </Select>
        </Form.Item>
      )}

      {!hideFields?.includes(STATE_ID) && (
        <Form.Item name={STATE_ID} label="State">
          <Select id="case-filter-state-select" placeholder="Filter by state">
            {states?.map((s) => <Option key={s._id} value={s._id}>{s.name}</Option>)}
          </Select>
        </Form.Item>
      )}

      {!hideFields?.includes(TYPE) && (
        <Form.Item name={TYPE} label="Consultation Type">
          <Select id="case-filter-consult-type-select" placeholder="Filter by Type">
            {Object.values(ConsultTypeEnum).map((type) => (
              <Option key={type} value={type}>
                {capitalize(type)}
              </Option>
            ))}
          </Select>
        </Form.Item>
      )}

      {!hideFields?.includes(CREATED_DATE_RANGE) && (
        <Form.Item name={CREATED_DATE_RANGE} label="Created Date Range">
          <RangePicker id="case-filter-created-date-range-picker" style={{ width: "100%" }} />
        </Form.Item>
      )}

      {!hideFields?.includes(UPDATED_DATE_RANGE) && (
        <Form.Item name={UPDATED_DATE_RANGE} label="Updated Date Range">
          <RangePicker id="case-filter-updated-date-range-picker" style={{ width: "100%" }} />
        </Form.Item>
      )}

      {!hideFields?.includes(COMPLETED_DATE_RANGE) && (
        <Form.Item name={COMPLETED_DATE_RANGE} label="Completed Date Range">
          <RangePicker id="case-filter-completed-date-range-picker" style={{ width: "100%" }} />
        </Form.Item>
      )}

      {!hideFields?.includes(CASE_TAGS) && (
          <Form.Item name={BOOKMARKED} label="Bookmarked Cases">
            <SwitchWrapper />
          </Form.Item>
      )}

    </Form>
  )
}

export default FilterForm;
